(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mcp-similar-bar-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MQ = '(max-width:749px)';
  function mob(){ return window.matchMedia(MQ).matches; }
  function themeAtcBtn(){
    return document.querySelector('.product-info product-form button[type="submit"]')
        || document.querySelector('form[id^="product-form-main-"] buy-buttons button[type="submit"]')
        || document.querySelector('form[id^="product-form-main-"] button[type="submit"]');
  }
  function setText(el, val){
    if(!el){ return; }
    if(val){
      if(el.textContent !== val){ el.textContent = val; }
      if(el.style.display === 'none'){ el.style.display = ''; }
    } else if(el.style.display !== 'none'){
      el.style.display = 'none';
    }
  }
  function applyBcText(){
    var box = document.querySelector('.product-info__block-item[data-block-id="mcp_buyers_choice"]');
    if(!box){ return; }
    var data = document.getElementById('mcp-bc-data');
    var heading = data ? (data.getAttribute('data-heading') || '') : '';
    var sub = data ? (data.getAttribute('data-sub') || '') : '';
    setText(box.querySelector('.mcp-rg__ey'), heading);
    setText(box.querySelector('.mcp-rg__sub'), sub);
    var hd = box.querySelector('.mcp-rg__hd');
    if(hd){ var t = (heading || sub) ? '' : 'none'; if(hd.style.display !== t){ hd.style.display = t; } }
  }
  function init(){
    applyBcText();
    var bar = document.getElementById('mcp-bar');
    var toggle = document.getElementById('mcp-bar-toggle');
    var panel = document.getElementById('mcp-bar-panel');
    var atc = document.getElementById('mcp-bar-atc');
    function sync(){ if(!atc){ return; } var t = themeAtcBtn(); var d = t ? (!!t.disabled || t.getAttribute('aria-disabled') === 'true') : true; if(atc.disabled !== d){ atc.disabled = d; } }
    if(bar){
      document.documentElement.classList.add('mcp-has-bar');
      if(bar.parentElement !== document.body){ document.body.appendChild(bar); }
      if(toggle && panel){
        toggle.addEventListener('click', function(){
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          if(open){ panel.setAttribute('hidden',''); } else { panel.removeAttribute('hidden'); }
        });
      }
      if(atc){
        atc.addEventListener('click', function(e){ e.preventDefault(); var t = themeAtcBtn(); if(t && !t.disabled){ t.click(); } });
      }
    }
    sync();
    document.addEventListener('change', sync, true);
    var host = document.querySelector('product-rerender[observe-form]') || document.querySelector('.product-info') || document.body;
    if(typeof MutationObserver !== 'undefined'){
      try{ new MutationObserver(function(){ applyBcText(); sync(); }).observe(host, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled','aria-disabled']}); }catch(e){}
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();

  } catch(e) { console.error(e); }
})();
})();
